"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils = require("../../../common/utils");
var autoCloseTag_1 = require("./autoCloseTag");
var monacoUtils_1 = require("../monacoUtils");
var CommonEditorRegistry = monaco.CommonEditorRegistry;
var EditorAction = monaco.EditorAction;
var KeyMod = monaco.KeyMod;
var KeyCode = monaco.KeyCode;
var EditorContextKeys = monaco.EditorContextKeys;
var WriteCode = /** @class */ (function (_super) {
    __extends(WriteCode, _super);
    function WriteCode() {
        return _super.call(this, {
            id: 'editor.action.writeCode',
            label: 'Write Code',
            alias: 'Write Code',
            precondition: EditorContextKeys.Focus,
            kbOpts: {
                kbExpr: EditorContextKeys.TextFocus,
                primary: KeyMod.CtrlCmd | KeyMod.Shift | KeyCode.KEY_X
            }
        }) || this;
    }
    WriteCode.prototype.run = function (accessor, editor) {
        /** Load current contents */
        var contents = monacoUtils_1.getSelectionOrCurrentLine(editor);
        /** Replace with nothing */
        monacoUtils_1.replaceSelection({ editor: editor, newText: '' });
        /** Send keys one by one */
        var model = editor.getModel();
        var currentPos = editor.getSelection().getStartPosition();
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                var i, _i, _a, char;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            autoCloseTag_1.disableAutoClose();
                            /** Wait a bit before starting. Helps us get a clean start screenshot. */
                            return [4 /*yield*/, utils.delay(500)];
                        case 1:
                            /** Wait a bit before starting. Helps us get a clean start screenshot. */
                            _b.sent();
                            i = 0;
                            _i = 0, _a = contents.split('');
                            _b.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 8];
                            char = _a[_i];
                            monacoUtils_1.writeString({ model: model, str: char, pos: { lineNumber: currentPos.lineNumber, column: currentPos.column } });
                            if (!!char.match(/\s/g)) return [3 /*break*/, 4];
                            // 160 words per minute (VERY FAST TYPING!)
                            // => 10 chars per second
                            // => 100ms
                            // + personal taste tweek gives us:
                            return [4 /*yield*/, utils.delay(120)];
                        case 3:
                            // 160 words per minute (VERY FAST TYPING!)
                            // => 10 chars per second
                            // => 100ms
                            // + personal taste tweek gives us:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 4: // For whitespace
                        return [4 /*yield*/, utils.delay(20)];
                        case 5:
                            _b.sent();
                            _b.label = 6;
                        case 6:
                            /**
                             * Advance pos
                             */
                            currentPos = model.modifyPosition(currentPos, 1);
                            /**
                             * Ensure position is well scrolled into
                             */
                            editor.revealPosition(currentPos);
                            _b.label = 7;
                        case 7:
                            _i++;
                            return [3 /*break*/, 2];
                        case 8:
                            autoCloseTag_1.enableAutoClose();
                            return [2 /*return*/];
                    }
                });
            });
        })();
    };
    return WriteCode;
}(EditorAction));
CommonEditorRegistry.registerEditorAction(new WriteCode());



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/addons/writeCode.js
 ** module id = 422
 ** module chunks = 0
 **/